import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Slot } from 'icreate/common/models/slot';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SlotService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(fcuId: string, fuId: string) {
        return await lastValueFrom(
            this.http.get<Slot[]>(`${this.domain}/api/slot`, {
                headers: this.headers,
                params: { fcuId, fuId },
            })
        );
    }

    async getByVesselId(vesselId: string) {
        return await lastValueFrom(
            this.http.get<Slot[]>(`${this.domain}/api/slot/vessel`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(slotData: Slot[], fcuIndex: number) {
        return await lastValueFrom(
            this.http.post<Slot[]>(
                `${this.domain}/api/slot`,
                { slotData, fcuIndex },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async update(slotData: Slot[], fcuIndex: number) {
        return await lastValueFrom(
            this.http.put<Slot[]>(
                `${this.domain}/api/slots`,
                { slotData, fcuIndex },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async deleteSlot(slotId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/slot/${slotId}`));
    }
}
